export const COVERAGE_URL = 'coverage'
